import { render } from "./ActionAddInternalNotesEditor.vue?vue&type=template&id=4d3f9fdb&scoped=true"
import script from "./ActionAddInternalNotesEditor.vue?vue&type=script&lang=js"
export * from "./ActionAddInternalNotesEditor.vue?vue&type=script&lang=js"

import "./ActionAddInternalNotesEditor.vue?vue&type=style&index=0&id=4d3f9fdb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3f9fdb"]])

export default __exports__